import { Box, Card, CardContent, CardActionArea, Grid, Typography, Chip, Skeleton } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { useQuery } from '@tanstack/react-query';
import { accountsApi, Account } from '../api/accounts';

const statusColor: Record<string, 'success' | 'error' | 'warning'> = {
  ACTIVE: 'success', FROZEN: 'warning', CLOSED: 'error',
};

export default function AccountsPage() {
  const navigate = useNavigate();
  const { data: res, isLoading } = useQuery({
    queryKey: ['accounts'],
    queryFn: () => accountsApi.list(),
  });

  const accounts: Account[] = res?.data ?? [];
  const fmt = (n: string) =>
    new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD' }).format(parseFloat(n));

  if (isLoading) {
    return (
      <Box>
        <Typography variant="h4" gutterBottom>Accounts</Typography>
        <Grid container spacing={2}>
          {[1, 2, 3].map((i) => (
            <Grid item xs={12} sm={6} md={4} key={i}><Skeleton variant="rounded" height={140} /></Grid>
          ))}
        </Grid>
      </Box>
    );
  }

  return (
    <Box>
      <Typography variant="h4" gutterBottom>Accounts</Typography>
      <Grid container spacing={2}>
        {accounts.map((account) => (
          <Grid item xs={12} sm={6} md={4} key={account.id}>
            <Card variant="outlined">
              <CardActionArea onClick={() => navigate(`/accounts/${account.id}`)}>
                <CardContent>
                  <Box sx={{ display: 'flex', justifyContent: 'space-between', mb: 1 }}>
                    <Typography variant="subtitle2">{account.accountType}</Typography>
                    <Chip label={account.status} size="small"
                      color={statusColor[account.status] ?? 'default'} />
                  </Box>
                  <Typography variant="body2" color="text.secondary">{account.accountNumber}</Typography>
                  <Typography variant="h5" sx={{ mt: 1 }}>{fmt(account.balance)}</Typography>
                  <Typography variant="caption" color="text.secondary">
                    Available: {fmt(account.availableBalance)}
                  </Typography>
                </CardContent>
              </CardActionArea>
            </Card>
          </Grid>
        ))}
        {accounts.length === 0 && (
          <Grid item xs={12}>
            <Typography color="text.secondary">No accounts found.</Typography>
          </Grid>
        )}
      </Grid>
    </Box>
  );
}
